import React, { useEffect, useState } from 'react'

import classNames from 'classnames'
import { styles } from '../SocialLink/styles'
import { makeStyles } from '@material-ui/styles'
import { PasswordModal } from '../PasswordModal/PasswordModal'
import { requestResetPassword } from 'Reducers/Auth/actions'
import { useDispatch } from 'react-redux'

export const CreateResetPassword = user => {
  const dispatch = useDispatch()
  const useStyles = makeStyles(styles)
  const classes = useStyles()
  const [isModalOpen, setModalOpen] = useState(false)
  const [emailSent, setEmailSent] = useState(false)
  const [countdown, setCountdown] = useState(0)

  const handlePasswordModal = () => setModalOpen(true)
  const handleClosePasswordModal = () => setModalOpen(false)

  const isPasswordCreated = user.user.hasPassword

  useEffect(() => {
    let timer
    if (emailSent) {
      timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(timer)
            setEmailSent(false)
            return 0
          }
          return prev - 1
        })
      }, 1000)
    }

    return () => clearInterval(timer)
  }, [emailSent])

  const handleSendEmail = () => {
    setEmailSent(true)
    setCountdown(30)
    dispatch(requestResetPassword(user.user.email))
  }
  return (
    <div className={classNames(classes.securityItem, classes.borderBottom)}>
      <div>
        <p className={classes.buttonLabel}>Password</p>
      </div>
      <button className={classes.securityButton} onClick={handlePasswordModal}>
        {isPasswordCreated ? 'Update password' : 'Create password'}
      </button>
      {isModalOpen && (
        <PasswordModal
          onClose={handleClosePasswordModal}
          emailSent={emailSent}
          countdown={countdown}
          handleSendEmail={handleSendEmail}
          isPasswordCreated={isPasswordCreated}
        />
      )}
    </div>
  )
}
